import { __decorate, __metadata } from "tslib";
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { UseRestraints } from '@core/shared/restraints';
import { AllowHtml, CrudEndpoints, EditorDefinition, Expose, IdItemModel, IsBoolean, ItemModelDefinition, ItemModelProp, MinLength, ModelId, Structure, Trim, ValidateNested } from '@core/shared/model';
import { DocentItem } from '@mpf/docents/shared';
import { CertificateItem } from './certificate.item';
import { CourseAttachmentItem } from './course-attachment.item';
import { CourseRestraints } from './course.restraints';
import { ExamItem } from './exam.item';
import { SceneItem } from './scene.item';
let CourseItem = /*#__PURE__*/(() => {
  let CourseItem = class CourseItem extends IdItemModel {
    toString() {
      return "Course " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], CourseItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], CourseItem.prototype, "updateDate", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "enabled", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "teaser", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "highlight", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "hasExam", void 0);
  __decorate([IsBoolean(), Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "hasCertificate", void 0);
  __decorate([MinLength(3), Expose(), Trim(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], CourseItem.prototype, "name", void 0);
  __decorate([MinLength(3), Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), __metadata("design:type", String)], CourseItem.prototype, "shortName", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], CourseItem.prototype, "docentId", void 0);
  __decorate([Expose(), __metadata("design:type", DocentItem)], CourseItem.prototype, "docent", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), AllowHtml(), __metadata("design:type", String)], CourseItem.prototype, "description", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", String)], CourseItem.prototype, "mandatoryNote", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Object)], CourseItem.prototype, "category", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], CourseItem.prototype, "tags", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: 0
  }), __metadata("design:type", Number)], CourseItem.prototype, "eduCreditPoints", void 0);
  __decorate([Expose()
  // default must be undefined for relation!
  , ItemModelProp({
    defaultValueCreate: undefined
  }), Structure(Array, () => SceneItem), __metadata("design:type", Array)], CourseItem.prototype, "scenes", void 0);
  __decorate([Expose(), Structure(Array, () => CourseAttachmentItem), ValidateNested(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], CourseItem.prototype, "attachments", void 0);
  __decorate([Expose(), ValidateNested(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", Array)], CourseItem.prototype, "_attachments", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", ExamItem)], CourseItem.prototype, "exam", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined
  }), __metadata("design:type", CertificateItem)], CourseItem.prototype, "certificate", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: false
  }), __metadata("design:type", Boolean)], CourseItem.prototype, "isMandatory", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], CourseItem.prototype, "duration", void 0);
  CourseItem = __decorate([EditorDefinition('admin-create', {
    name: true,
    shortName: true,
    description: true,
    category: true
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-general', {
    enabled: true,
    teaser: true,
    highlight: true,
    name: true,
    shortName: true,
    docentId: true,
    thumbnail: true,
    description: true,
    mandatoryNote: true,
    eduCreditPoints: true,
    tags: true,
    category: true,
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-attachments', {
    attachments: {
      loadDefinition: 'admin'
    }
  }, {
    useCrudEndpoint: 'admin'
  }), EditorDefinition('admin-certificate', {
    certificate: {
      loadDefinition: 'admin-certificate'
    }
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    public: '/courses',
    admin: '/admin/courses'
  }, {
    clientCache: {
      seconds: 15 * 60,
      clearOnUserChange: true,
      // no caching of ReadOne as it is updated frequently with new userProgress
      endpoints: {
        public: ['ReadMany'],
        admin: true
      }
    }
  }), UseRestraints(CourseRestraints), ItemModelDefinition({
    texts: {
      item: 'Kurs',
      items: 'Kurse',
      newItem: 'Neuen Kurs erstellen'
    }
  }), MediaAssets(['thumbnail']), ModelId("CourseItem") // auto-generated by generate-model-ids
  ], CourseItem);
  return CourseItem;
})();
export { CourseItem };